import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import Bowser from 'bowser'
import {UserAgentState} from './types'
import isKakaoBrowser from '@/validate/is-kakao-browser'
import isInAppBrowser from '@/validate/is-in-app-browser'

export {UserAgentState}
const initState: UserAgentState = {
  ...Bowser.parse(window.navigator.userAgent),
  isInAppBrowser: isInAppBrowser(window.navigator.userAgent),
  isKakaoBrowser: isKakaoBrowser(window.navigator.userAgent),
}

const module: ModuleFc<UserAgentState> = () => ({
  namespaced: true,
  state: cloneDeep(initState),
  getters: {
    isIE(state) {
      return state.browser.name === 'Internet Explorer'
    },
    isIOS(state) {
      return state.os?.name === 'iOS'
    },
    isAndroid(state) {
      return state.os?.name === 'Android'
    },
    isChromeBrowser(state) {
      return state.browser?.name === 'Chrome'
    },
    isSafariBrowser(state) {
      return state.browser?.name === 'Safari'
    },
    isSamsungBrowser(state) {
      return state.browser?.name === 'Samsung Internet for Android'
    },
    isMobile(state) {
      return state.platform?.type === 'mobile'
    },
    availableAddToHomeScreen(state, getters) {
      return (getters.isIOS && getters.isSafariBrowser) ||
        (getters.isAndroid && getters.isChromeBrowser || getters.isSamsungBrowser)
    },
  },
})

export default module
